
export const AppliedEvaluationStatus: any = {
    NAO_INICIADO: 0,
    EM_ANDAMENTO: 1,
    AGUARDANDO_APROVACAO: 2,
    CONCLUIDO: 3,
    REPROVADO: 4,
    ATRASADO: 5,
    EM_VERIFICACAO: 6,
    AGUARDANDO_CONCLUSAO: 7,
    allStatus: {
        0: { text: 'Não Iniciado', color: 'disabled', key: 0 },
        1: { text: 'Em andamento', color: 'primary', key: 1 },
        2: { text: 'Aguardando Aprovação do supervisor', color: 'light', key: 2 },
        3: { text: 'Concluído', color: 'secondary', key: 3 },
        4: { text: 'Reprovado', color: 'danger', key: 4 },
        5: { text: 'Atrasado', color: 'warning', key: 5 },
        6: { text: 'Em Verificação do avaliado', color: 'light', key: 6 },
        7: { text: 'Aguardando Conclusão do avaliador', color: 'light', key: 7 }
    }
}


// WEBPACK FOOTER //
// ./src/services/applied-evaluation-status-constant.ts